import { EventStatus } from '../services/Types';

export interface StatusColors {
  backgroundColor: string;
  color: string;
  label: string;
}

export const getStatusColors = (status: string): StatusColors => {
  switch (status) {
    case EventStatus.SAVED:
      return {
        backgroundColor: 'rgba(0, 107, 215, 1)', // #006BD7
        color: '#FFFFFF',
        label: 'Draft'
      };

    case EventStatus.APPROVAL1:
      return {
        backgroundColor: 'rgba(251, 192, 45, 1)', // #FBC02D
        color: '#333333',
        label: 'Pending PO Approval'
      };

    case EventStatus.APPROVAL2:
      return {
        backgroundColor: 'rgba(242, 58, 0, 1)', // #F23A00
        color: '#FFFFFF',
        label: 'Pending L2 Approval'
      };

    case EventStatus.APPROVAL3:
      return {
        backgroundColor: 'rgba(197, 17, 98, 1)', // #C51162
        color: '#FFFFFF',
        label: 'Pending L3 Approval'
      };

    case EventStatus.APPROVED:
      return {
        backgroundColor: '#34C759',
        color: '#333333',
        label: 'Approved and Booked'
      };

    case EventStatus.BLOCKED:
      return {
        backgroundColor: 'rgba(117, 117, 117, 1)', // #757575
        color: '#FFFFFF',
        label: 'Blocked'
      };

    case EventStatus.CANCELLED:
      return {
        backgroundColor: '#FF3B30',
        color: '#FFFFFF',
        label: 'Cancelled'
      };

    case EventStatus.REJECTED:
      return {
        backgroundColor: '#FF3B30',
        color: '#FFFFFF',
        label: 'Rejected'
      };

    case 'APPROVAL_PENDING':
      return {
        backgroundColor: 'rgba(255, 87, 34, 1)', // #FF5722
        color: '#FFFFFF',
        label: 'Pending Approval'
      };

    case 'DRY':
      return {
        backgroundColor: 'rgba(98, 0, 234, 1)', // #6200EA
        color: '#FFFFFF',
        label: 'Dry Run'
      };

    case 'ETA':
      return {
        backgroundColor: '#006BD7',
        color: '#FFFFFF',
        label: 'ETA'
      };

    case 'DORMANT':
      return {
        backgroundColor: 'rgba(135, 206, 250, 0.9)', // light blue
        color: '#1a1a1a',
        label: 'Dormant'
      };

    default:
      return {
        backgroundColor: '#CCCCCC',
        color: '#3B3B3F',
        label: status || 'Unknown'
      };
  }
};

// Helper function to get just the background color
export const getStatusBackgroundColor = (status: string): string => {
  return getStatusColors(status).backgroundColor;
};

// Helper function to get just the text color
export const getStatusTextColor = (status: string): string => {
  return getStatusColors(status).color;
};



// Helper function to get just the label
export const getStatusLabel = (status: string): string => {
  return getStatusColors(status).label;
}; 